import Vue from 'vue';
import optimusApi from '../optimus/api';
import Item from './item';

const ITEMS_EXPLORE_REQUEST = 'ITEMS_EXPLORE_REQUEST',
    ITEMS_EXPLORE_SUCCESS = 'ITEMS_EXPLORE_SUCCESS',
    ITEMS_EXPLORE_ERROR = 'ITEMS_EXPLORE_ERROR',
    ITEM_DETAILS_REQUEST = 'ITEM_DETAILS_REQUEST',
    ITEM_DETAILS_SUCCESS = 'ITEM_DETAILS_SUCCESS',
    ITEM_DETAILS_ERROR = 'ITEM_DETAILS_ERROR',
    ITEM_INSTALL_REQUEST = 'ITEM_INSTALL_REQUEST',
    ITEM_INSTALL_SUCCESS = 'ITEM_INSTALL_SUCCESS',
    ITEM_INSTALL_ERROR = 'ITEM_INSTALL_ERROR',
    SET_ITEM_INSTALL_ERROR = 'SET_ITEM_INSTALL_ERROR',
    RESET_ITEM_INSTALL = 'RESET_ITEM_INSTALL',
    UPDATE_TEMPLATE_OPTIONS_VALUE = 'UPDATE_TEMPLATE_OPTIONS_VALUE',
    START_APP_AUTH_REDIRECT = 'START_APP_AUTH_REDIRECT',
    START_APP_AUTH_POST = 'START_APP_AUTH_POST',
    START_APP_AUTH = 'START_APP_AUTH',
    APP_AUTH_ERROR = 'APP_AUTH_ERROR',
    APP_AUTH_SUCCESS = 'APP_AUTH_SUCCESS',
    SET_APP = 'SET_APP',
    SET_APP_IDENTITY = 'SET_APP_IDENTITY',
    RESET_APP_AUTH_STATUS = 'RESET_APP_AUTH_STATUS';


const state = {
    exploreItems: [],
    exploreStatus: {},
    selectedItem: null,
    selectedItemStatus: {},
    installStatus: {},
    appIdentity: null,
    installContext: {},
    app: null,
    appAuthorizationStatus: {}  
};

const getters = {
    exploreItems: state => state.exploreItems,
    exploreStatus: state => state.exploreStatus,
    selectedItem: state => state.selectedItem,
    selectedItemStatus: state => state.selectedItemStatus,
    installStatus: state => state.installStatus,
    appIdentity: state => state.appIdentity,
    installContext: state => state.installContext,
    app: state => state.app,
    appAuthorizationStatus: state => state.appAuthorizationStatus
};

const actions = {
    [START_APP_AUTH_REDIRECT]: ({ commit, dispatch, rootGetters }, payload) => {
        commit(START_APP_AUTH);
		optimusApi.startAppAuthentication({ itemId: payload.itemId })
			.then(response => {
                if (response.location) {
                    window.location = response.location;
                }
			})
			.catch(error => {
                console.log(error);
                commit(APP_AUTH_ERROR);
			});
    },
    [START_APP_AUTH_POST]: ({ commit, dispatch, rootGetters }, payload) => {
        commit(START_APP_AUTH);
        if (payload.strategy === 'initst') {
            let client = `https://${rootGetters.ENVIRONMENT === 'development' ? 'dev-' : ''}account.initialstate.com`;
            optimusApi.appAuthenticationCustom({ client, data: payload.data })
                .then(response => {
                    return optimusApi.postAppAuthentication({ appId: payload.appId, itemId: payload.itemId, data: response });
                })
                .then(response => {
                    commit(APP_AUTH_SUCCESS);
                    if (response.appIdentity) {
                        commit(SET_APP_IDENTITY, response.appIdentity);
                    }
                })
                .catch(error => {
                    console.log(error);
                    commit(APP_AUTH_ERROR, error);
                });
        } else {
            // password grant POST
            optimusApi.postAppAuthentication({ appId: payload.appId, itemId: payload.itemId, data: payload.data })
                .then(response => {
                    commit(APP_AUTH_SUCCESS);

                    // grab mp item again so we have latest item, app, appidentity, and install context
                    dispatch(ITEM_DETAILS_REQUEST, { itemId: payload.itemId, includeApp: true, includeAppIdentity: true });
                })
                .catch(error => {
                    console.log(error);
                    commit(APP_AUTH_ERROR, error);
                });
        }
    },
    [RESET_APP_AUTH_STATUS]: ({ commit, dispatch, rootGetters }) => {
        commit(RESET_APP_AUTH_STATUS);
    },
	[ITEMS_EXPLORE_REQUEST]: ({ commit, dispatch, rootGetters }, payload) => {
		commit(ITEMS_EXPLORE_REQUEST);
		optimusApi.getExploreItems()
			.then(response => {
                let items = response.items.map(Item.fromDTO);

				commit(ITEMS_EXPLORE_SUCCESS, items);
			})
			.catch(error => {
				commit(ITEMS_EXPLORE_ERROR);
			});
    },
    [ITEM_DETAILS_REQUEST]: ({ commit, dispatch, rootGetters }, payload) => {
        commit(ITEM_DETAILS_REQUEST);
		optimusApi.getItem(payload)
			.then(response => {
                let item = Item.fromDTO(response.item);
                commit(ITEM_DETAILS_SUCCESS, item);

                if (payload.includeAppIdentity) {
                    commit(SET_APP_IDENTITY, response.appIdentity);
                }
                if (payload.includeApp) {
                    commit(SET_APP, response.app);
                }
			})
			.catch(error => {
				commit(ITEM_DETAILS_ERROR);
			});
    },
    [UPDATE_TEMPLATE_OPTIONS_VALUE]: ({ commit, dispatch, rootGetters }, payload) => {
		commit(UPDATE_TEMPLATE_OPTIONS_VALUE, payload);
    },
    [ITEM_INSTALL_REQUEST]: ({ commit, dispatch, rootGetters }, payload) => {
		commit(ITEM_INSTALL_REQUEST);
        optimusApi.addMarketplaceItem(payload)
            .then(response => {
                commit(ITEM_INSTALL_SUCCESS, { newBucketId: response.newBucketId });
                dispatch('GET_STATS_REQUEST', { credits: true});
            })
            .catch(error => {
                let errorMessage = null;
                if (error && error.type) {
                    let type = error.type;
                    if (['INVALID_BUCKET_KEY', 'INVALID_ACCESS_KEY', 'INSUFFICIENT_CREDITS'].includes(type)) {
                        errorMessage = error.message;
                    } else if (type === 'INVALID_TEMPLATE_VALUES') {
                        errorMessage = 'Hmm... please double check your configuration values.';
                    }
                }
                commit(ITEM_INSTALL_ERROR, errorMessage);
            });
    },
    [RESET_ITEM_INSTALL]: ({ commit, dispatch, rootGetters }, payload) => {
		commit(RESET_ITEM_INSTALL);
    },
    [SET_ITEM_INSTALL_ERROR]: ({ commit, dispatch, rootGetters }, msg) => {
		commit(ITEM_INSTALL_ERROR, msg);
    },
};

const mutations = {
	[ITEMS_EXPLORE_REQUEST]: (state) => {
        state.exploreItems = [];
		state.exploreStatus = {
			loading: true
        };
	},
	[ITEMS_EXPLORE_SUCCESS]: (state, items) => {
		state.exploreStatus = {
			success: true
        };
        state.exploreItems = items;
	},
	[ITEMS_EXPLORE_ERROR]: (state) => {
		state.exploreStatus = {
			error: true
		};
    },
	[ITEM_INSTALL_REQUEST]: (state) => {
		state.installStatus = {
            loading: true,
            success: false,
            error: false,
            errorMessage: null
		};
	},
	[ITEM_INSTALL_SUCCESS]: (state, data) => {
		state.installStatus = {
			success: true,
            loading: false,
            newBucketId: data.newBucketId
        };
	},
	[ITEM_INSTALL_ERROR]: (state, msg) => {
		state.installStatus = {
            error: true,
            errorMessage: msg
		};
    },
    [ITEM_DETAILS_REQUEST]: (state) => {
        state.selectedItem = null;
        state.appIdentity = null;
        state.installContext = {};
        state.app = null;
		state.selectedItemStatus = {
			loading: true
        };
	},
    [ITEM_DETAILS_SUCCESS]: (state, item) => {
		state.selectedItemStatus = {
			success: true
        };
        state.selectedItem = item;
	},
	[ITEM_DETAILS_ERROR]: (state) => {
		state.selectedItemStatus = {
			error: true
		};
    },
    [RESET_ITEM_INSTALL]: (state) => {
        state.installStatus = {};
    },
    [UPDATE_TEMPLATE_OPTIONS_VALUE]: (state, data) => {
        let newVal;
        if (data.eventOrValue.target) {
            // treat as an event
            let e = data.eventOrValue;
            if (e.target.type === 'number') {
                newVal = e.target.valueAsNumber;
            } else {
                newVal = e.target.value;
            }
        } else {
            // not an event - data from vue-select or similar
            newVal = data.eventOrValue;
        }
        let opt = data.templateOption;
        let idx = data.templateOptionListIndex;
        state.selectedItem.templateOptions[opt][idx].value = newVal;
    },
    [SET_APP_IDENTITY]: (state, appIdentity) => {
        state.appIdentity = appIdentity;
        if (appIdentity && appIdentity.profile) {
            state.installContext = { profile: appIdentity.profile };
        }
    },
    [SET_APP]: (state, app) => {
        state.app = app;
    },
    [START_APP_AUTH]: (state) => {
        state.appAuthorizationStatus = {
            loading: true
        };
    },
    [APP_AUTH_ERROR]: (state, error) => {
        state.appAuthorizationStatus = {
            loading: false,
            error: true,
            errorType: error && error.type || null
        };
    },
    [APP_AUTH_SUCCESS]: (state) => {
        state.appAuthorizationStatus = {
            loading: false,
            success: true
        };
    },
    [RESET_APP_AUTH_STATUS]: (state) => {
        state.appAuthorizationStatus = {
            loading: false
        };
    },
    
};

export default {
	state,
	getters,
	actions,
	mutations,
};



// WEBPACK FOOTER //
// ./src/modules/marketplace/store.js